export default __webpack_public_path__ + "static/media/arrow-right.a467fda8.svg";